import { ENTITY, UserActions } from '@/enums';
import useCheckScopeCombinations from '@/hooks/useCheckScopeCombinations';
import { channelService } from '@/services/api-services';
import { useQuery } from '@tanstack/react-query';
import { newQueryKeys } from './queryKeys';

const useGetChannel = () => {
  const { canGetChannel } = useCheckScopeCombinations(
    [[{ entity: ENTITY.CHANNEL, action: UserActions.GET }]],
    { optimistic: false },
  );

  const query = useQuery({
    queryKey: newQueryKeys.channel.invalidateListsKey(),
    queryFn: channelService.findChannel,
    staleTime: Infinity,
    gcTime: Infinity,
    enabled: canGetChannel,
  });

  return query;
};

export { useGetChannel };
